module.exports = __webpack_public_path__ + "media/images/talent/case05-illust-172f40c09d439be3cbb9125ff3539faf.png";